export const PERSONAL_ITEMS_QR_GLU = ',';
